import apiClient from 'services/axios'
import ApiConfig from 'services/config'
// import errorHandler from 'components/error.handler'

function getBrand(businessCode) {
  return apiClient
    .get(`${ApiConfig.BrandConfig.Brand}${businessCode}`)
    .then(response => response?.data)
}

export default getBrand
